import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import PilotApplication from "./pages/PilotApplication";
import PilotPage from "./pages/PilotPage";
import AboutPage from "./pages/AboutPage";
import SupportPage from "./pages/SupportPage";
import EmergencyOutreachPage from "./pages/EmergencyOutreachPage";
import OverdoseResponsePage from "./pages/OverdoseResponsePage";
import DrinkSpikeDetectionPage from "./pages/DrinkSpikeDetectionPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AutoShopsPage from "./pages/AutoShopsPage";
import QrPosterPage from "./pages/QrPosterPage";

// Scroll to the element referenced by URL hash on navigation.
const ScrollToHash = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.slice(1);
            // Delay so the destination page has rendered.
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0A1428",
                        color: "#fff",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: 2,
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
            <BrowserRouter>
                <ScrollToHash />
                <Routes>
                    <Route path="/" element={<HomePage />} />

                    {/* Public Safety */}
                    <Route path="/public-safety/overdose-response" element={<OverdoseResponsePage />} />
                    <Route path="/public-safety/drink-spike-detection" element={<DrinkSpikeDetectionPage />} />

                    {/* Alert & Automation */}
                    <Route path="/alert-automation" element={<EmergencyOutreachPage />} />

                    {/* Backward compatibility redirects */}
                    <Route path="/overdose-response" element={<Navigate to="/public-safety/overdose-response" replace />} />
                    <Route path="/emergency-outreach" element={<Navigate to="/alert-automation" replace />} />

                    <Route path="/pilot" element={<PilotPage />} />
                    <Route path="/pilot-application" element={<PilotApplication />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/support" element={<SupportPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/privacy" element={<PrivacyPolicyPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/auto-shops" element={<AutoShopsPage />} />
                    <Route path="/qr-poster" element={<QrPosterPage />} />
                    <Route path="/qr" element={<Navigate to="/qr-poster" replace />} />
                    <Route path="/auto" element={<Navigate to="/auto-shops" replace />} />
                    <Route path="/shop" element={<Navigate to="/auto-shops" replace />} />
                    <Route path="/oil" element={<Navigate to="/auto-shops" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
